import StyledBody from "../StyledBody/StyledBody";
import MainGrid from "../MainGrid/MainGrid";
const Home=()=>{
    return(
        <StyledBody>
            <MainGrid/>
        </StyledBody>
    );
}
export default Home;